import { Collapse } from 'react-bootstrap';
import DoctorLetterForm from './components/DoctorLetterForm';
import { useState } from 'react';
import editIcon from '../../../../../assets/img/button-icons/edit-pen-outline.svg';
import { Download } from 'react-bootstrap-icons';
import CareMapprIconButton from '../../../../components/Button/CareMapprIconButton';
import { useLettersForm } from './provider/LettersFormContext';
import { LetterType } from './PharmacistDoctorLetterSection';
import CareMapprButton from '../../../../components/Button/CareMapprButton';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';

const DoctorLetter = () => {
  const { isDownloadingDoctor, onDownloadLetter } = useLettersForm();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex align-items-center justify-content-between px-2">
        <span className="letters-label">Doctor letter</span>
        <div className="d-flex align-items-center gap-2">
          <CareMapprIconButton
            className="m-0 min-width-50"
            icon={<img src={editIcon} className="icon" alt="edit pen icon" />}
            onClick={() => {
              setIsOpen(true);
            }}
          />
          <CareMapprButton
            extraClassNames="action-button"
            label={isDownloadingDoctor ? 'Downloading' : 'Download'}
            disabled={isDownloadingDoctor}
            variant="secondary"
            endIcon={
              isDownloadingDoctor ? (
                <LoadingSpinner size={16} color="primary" showText="" />
              ) : (
                <Download size={16} />
              )
            }
            type="button"
            onClick={() => {
              onDownloadLetter(LetterType.DOCTOR);
            }}
          />
        </div>
      </div>
      <Collapse
        in={isOpen}
        onEntered={() =>
          window.dispatchEvent(new Event('caremappr:collapse-entered'))
        }
      >
        <div>
          <DoctorLetterForm onClose={() => setIsOpen(false)} />
        </div>
      </Collapse>
    </div>
  );
};

export default DoctorLetter;
